export const getSortedTranslations = <V extends string>(translations: Record<string, V>): V[] => {
    return Object.keys(translations)
        .sort()
        .map(key => translations[key]);
};
